import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '../../../../icons/check-circle.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Tooltip from '@material-ui/core/Tooltip';
import './ButtonInput.scss';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function ButtonInput(props) {
    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow button-input-term ${props.value ? 'active mt-4 pt-0' : 'inactive mt-4 pt-0 border-white'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        >
            <span className={`w-100`}>
                <SvgIcon fontSize="large" color="primary" component={props.icon} className={props.infoText ?'icons mt-0 mr-0' : 'icons'} />
                {props.infoText &&
                    <Tooltip title={props.infoText} className='float-right m-0 '>
                        <LightTooltip >
                        <InfoIcon color="action"></InfoIcon>
                        </LightTooltip>
                    </Tooltip>
                }
                <h2 className="title mx-2">{props.title}</h2>
                <p className='subtitle'>{props.subtitle}</p>             
                <div>
                {
                    props.value ?
                        <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check" style={{ cursor: 'pointer' }} /> :
                        <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" style={{ cursor: 'pointer' }} />
                }
                </div>            
            </span>
        </Button>
    );
}

ButtonInput.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/SubComponent/ButtonInput.js